import Vue from 'vue'
import toastr from './toastr'
import * as Sentry from '@sentry/browser'

Vue.config.warnHandler = function(message, vm, trace) {
  console.error(`Vue Warn: ${message}\nTrace: ${trace}`)
  Sentry.captureException(`Vue Warn: ${message}\nTrace: ${trace}`)
}
Vue.config.errorHandler = function(message, vm, trace) {
  if (process.env.NODE_ENV !== 'production') {
    console.error(`Vue Error: ${message}\nTrace: ${trace}\n`)
  }
  Sentry.captureException(`Vue Error: ${message}\nTrace: ${trace}`)
}

const methods = {
  trans(id) {
    return Translator.trans(id)
  },
  dcNumberFormat(number, decimal = 2, forceFloat = true) {
    if (number === null || number === '' || number === undefined || isNaN(number)) {
      return ''
    }

    if (number === 0 && !forceFloat) {
      return '0'
    }

    return ~~number === number && !forceFloat ? number : new Intl.NumberFormat('pl-PL', {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    }).format(number)
  },
  translateUnit(name) {
    return name ? Translator.trans(`units.${name}`) : ''
  },
  calculateKcalToKj(kcal) {
    return Math.round(kcal * 4.184)
  }
}

Vue.mixin({
  filters: {
    trans: methods.trans,
    number: methods.dcNumberFormat,
    unit: methods.translateUnit,
  },
  methods: {
    trans: methods.trans,
    dcNumberFormat: methods.dcNumberFormat,
    translateUnit: methods.translateUnit,
    getUniqueValues(array) {
      return Array.from(new Set(array))
    },
    arrayToString(array, delimeter = ', ') {
      return array.join(delimeter)
    },
    refresh() {
      this.$forceUpdate()
    },
    handleAjaxError: function (response, entity = false, customMessage = false) {
      if (response.response) {
        response = response.response
      }

      let code = typeof response.status !== 'undefined' ? response.status : response.code
      $('.button-save').button('reset')
      switch (code) {
        case 400:
          toastr.error(response.data.messages)
          return
        case 422:
          if (entity instanceof Object) {
            entity.errors = response.data.errors
            return
          }
          this.errors = response.data.errors
          return
        case 423:
          toastr.error(response.data.error)
          return
        case 424:
          toastr.error(Translator.trans(response.data.message))
          return
        case 425:
          toastr.error(response.data.message)
          return
        case 500:
          toastr.error(customMessage ? customMessage : 'Internal error 500')
          return
        case 555:
          toastr.error(response.data.message)
          return
        default:
          toastr.error(`Internal error: code ${code}`)
      }
    },
    parseURLParams(url) {
      var queryStart = url.indexOf('?') + 1,
        queryEnd = url.indexOf('#') + 1 || url.length + 1,
        query = url.slice(queryStart, queryEnd - 1),
        pairs = query.replace(/\+/g, ' ').split('&'),
        parms = {}, i, n, v, nv

      if (query === url || query === '') return

      for (i = 0; i < pairs.length; i++) {
        nv = pairs[i].split('=', 2)
        n = decodeURIComponent(nv[0])
        v = decodeURIComponent(nv[1])

        if (!(n in parms)) {
          parms[n] = []
        }
        parms[n].push(nv.length === 2 ? v : null)
      }
      return parms
    },
    findObjectInArray(objectKey, objectValue, objects) {
      for (let i = 0; i < objects.length; i++) {
        if (objects[i][objectKey] === objectValue) {
          return objects[i]
        }
      }

      return null
    },
    printElement(element) {
      var mywindow = window.open('', 'PRINT', 'height=400,width=600')

      mywindow.document.write('<html><head><title></title>')
      mywindow.document.write(
        '</head><style> table, th, td { border: 1px solid black; } table { border-collapse: collapse; } </style><body >'
      )
      mywindow.document.write(document.getElementById(element).innerHTML)
      mywindow.document.write('</body></html>')

      mywindow.document.close() // necessary for IE >= 10
      mywindow.focus() // necessary for IE >= 10*/

      mywindow.print()
      mywindow.close()

      return true
    },
    calculateKcalToKj: methods.calculateKcalToKj,
    getNestedObjectValue(object, nestedKey) {
      const keys = nestedKey.split('.')
      let value = object

      for (const key of keys) {
        if (!value[key]) {
          return null
        } else if (typeof value[key] === 'object') {
          value = value[key]
        }
      }

      return value
    },
  },
})
